import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import styles from './info-panel.module.css'
import mouse from './mouse.svg'
import mouseSelected from './mouse-selected.svg'
import mousePan from './mouse-pan-view.svg'
import mouseZoom from './mouse-zoom-view.svg'
import mouseRotate from './mouse-rotate-view.svg'
import touch from './touch.svg'
import touchSelected from './touch-selected.svg'
import touchPan from './touch-pan-view.svg'
import touchRotate from './touch-rotate-view.svg'
import touchZoom from './touch-zoom-view.svg'
import touchTilt from './touch-tilt-view.svg'

export default function ViewerInfoPanel({ collapsed }) {
    const [mouseInfoShown, setMouseInfoShown] = useState(true);
    return (
        <div className={`${styles.container} ${collapsed ? styles.collapsed : ''}`}>
            <div className={styles.row}>
                <div className={`${styles.header} ${mouseInfoShown ? styles.selected : ''}`} onClick={() => setMouseInfoShown(true)}>
                    <img src={mouseInfoShown ? mouseSelected : mouse} />
                </div>
                <div className={`${styles.header} ${!mouseInfoShown ? styles.selected : ''}`} onClick={() => setMouseInfoShown(false)}>
                    <img src={!mouseInfoShown ? touchSelected : touch} />
                </div>
            </div>

            <div className={`${styles.content} ${!mouseInfoShown ? 'hidden' : ''}`}>
                <div className={styles.row}>
                    <div className={styles.infoImage}><img src={mousePan} /></div>
                    <div className={styles.infoText}>
                        <div className={styles.infoTextHeader}>Pan view</div>
                        <div>Left click + drag</div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.infoImage}><img src={mouseZoom} /></div>
                    <div className={styles.infoText}>
                        <div className={styles.infoTextHeader}>Zoom view</div>
                        <div>Right click + drag</div>
                        <div>Mouse wheel scroll</div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.infoImage}><img src={mouseRotate} /></div>
                    <div className={styles.infoText}>
                        <div className={styles.infoTextHeader}>Rotate view</div>
                        <div>Middle click + drag</div>
                        <div>CTRL+Left/Right click + drag</div>
                    </div>
                </div>
            </div>

            <div className={`${styles.content} ${mouseInfoShown ? 'hidden' : ''}`}>
                <div className={styles.row}>
                    <div className={styles.infoImage}><img src={touchPan} /></div>
                    <div className={styles.infoText}>
                        <div className={styles.infoTextHeader}>Pan view</div>
                        <div>One finger drag</div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.infoImage}><img src={touchRotate} /></div>
                    <div className={styles.infoText}>
                        <div className={styles.infoTextHeader}>Rotate view</div>
                        <div>Two finger drag</div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.infoImage}><img src={touchZoom} /></div>
                    <div className={styles.infoText}>
                        <div className={styles.infoTextHeader}>Zoom view</div>
                        <div>Two finger pinch</div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.infoImage}><img src={touchTilt} /></div>
                    <div className={styles.infoText}>
                        <div className={styles.infoTextHeader}>Tilt view</div>
                        <div>Two finger drag</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ViewerInfoPanel.propTypes = {
    collapsed: PropTypes.bool.isRequired
};